import React from "react";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { Tooltip } from "components";
import { FilterColumn } from "types";

import AgeErrorMessage from "./ageErrorMessage";
import DayHourMinuteSection from "./dayHourMinuteSection";
import useValidateMinMaxAge from "./useValidateMinMaxAge";

import styles from "../filter.module.scss";

type FilterColumnProps = {
	column: FilterColumn;
};

const FilterMinMaxAgePicker = ({ column }: FilterColumnProps) => {
	const { register } = useFormContext();
	const { isInvalid, handleBlur } = useValidateMinMaxAge({ column });

	return (
		<div className={styles.column}>
			<Tooltip
				trigger="click"
				position="bottom"
				interactive
				html={
					<div className={styles.agePickerContent}>
						<DayHourMinuteSection
							register={register}
							name={column.name}
							section={column.minSection}
							isCustomName={column?.isCustomName}
							isInvalid={isInvalid}
							onBlur={handleBlur}
						/>
						<hr />
						<DayHourMinuteSection
							register={register}
							name={column.name}
							section={column.maxSection}
							isCustomName={column?.isCustomName}
							isInvalid={isInvalid}
							onBlur={handleBlur}
						/>
						{isInvalid && <AgeErrorMessage />}
					</div>
				}
			>
				<Form.Control
					name={column.name}
					placeholder={column.placeholder}
					className={styles.input}
					readOnly
				/>
			</Tooltip>
		</div>
	);
};

export default FilterMinMaxAgePicker;

